import { statisticTypes } from './actions';
import { authTypes } from 'Containers/Auth/store/actions';

const initialState = {
  dashboard: null,
  finance: null,
  bookings: null,
  queue: null,
  clients: null,
  loadingDashboard: false,
  loadingFinance: false,
  loadingBookings: false,
  loadingQueue: false,
  loadingClients: false,
  unlockLoading: false,
  lockVersion: 0,
  unlockedVersion: 0,
};

const applySuccess = (state, key, loadingKey, action) => {
  const fromCache = !!action.options?.fromCache;
  return {
    ...state,
    [key]: action.payload,
    [loadingKey]: fromCache ? state[loadingKey] : false,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case authTypes.SET_ACTIVE_SALON.SUCCESS:
      return {
        ...state,
        finance: null,
        bookings: null,
        queue: null,
        clients: null,
        loadingFinance: false,
        loadingBookings: false,
        loadingQueue: false,
        loadingClients: false,
        unlockLoading: false,
        lockVersion: 0,
        unlockedVersion: 0,
      };
    case statisticTypes.UNLOCK_STATISTICS.REQUEST:
      return {
        ...state,
        unlockLoading: true,
      };
    case statisticTypes.UNLOCK_STATISTICS.SUCCESS:
      return {
        ...state,
        unlockLoading: false,
        unlockedVersion: (state.unlockedVersion || 0) + 1,
      };
    case statisticTypes.UNLOCK_STATISTICS.FAILED:
      return {
        ...state,
        unlockLoading: false,
      };
    case statisticTypes.STATISTICS_LOCKED.SUCCESS:
      return {
        ...state,
        finance: null,
        bookings: null,
        queue: null,
        clients: null,
        loadingFinance: false,
        loadingBookings: false,
        loadingQueue: false,
        loadingClients: false,
        lockVersion: (state.lockVersion || 0) + 1,
      };
    case statisticTypes.STATISTICS_SESSION_RESET.SUCCESS:
      return {
        ...state,
        finance: null,
        bookings: null,
        queue: null,
        clients: null,
        loadingFinance: false,
        loadingBookings: false,
        loadingQueue: false,
        loadingClients: false,
        unlockLoading: false,
        lockVersion: 0,
        unlockedVersion: 0,
      };
    case statisticTypes.GET_DASHBOARD.REQUEST:
      return {
        ...state,
        loadingDashboard: true,
      };
    case statisticTypes.GET_DASHBOARD.SUCCESS:
      return {
        ...state,
        dashboard: action.payload,
        loadingDashboard: false,
      };
    case statisticTypes.GET_DASHBOARD.FAILED:
      return {
        ...state,
        loadingDashboard: false,
      };
    case statisticTypes.GET_STATISTICS_FINANCE.REQUEST:
      return {
        ...state,
        loadingFinance: true,
      };
    case statisticTypes.GET_STATISTICS_FINANCE.SUCCESS:
      return applySuccess(state, 'finance', 'loadingFinance', action);
    case statisticTypes.GET_STATISTICS_FINANCE.FAILED:
      return {
        ...state,
        loadingFinance: false,
      };
    case statisticTypes.GET_STATISTICS_BOOKINGS.REQUEST:
      return {
        ...state,
        loadingBookings: true,
      };
    case statisticTypes.GET_STATISTICS_BOOKINGS.SUCCESS:
      return applySuccess(state, 'bookings', 'loadingBookings', action);
    case statisticTypes.GET_STATISTICS_BOOKINGS.FAILED:
      return {
        ...state,
        loadingBookings: false,
      };
    case statisticTypes.GET_STATISTICS_QUEUE.REQUEST:
      return {
        ...state,
        loadingQueue: true,
      };
    case statisticTypes.GET_STATISTICS_QUEUE.SUCCESS:
      return applySuccess(state, 'queue', 'loadingQueue', action);
    case statisticTypes.GET_STATISTICS_QUEUE.FAILED:
      return {
        ...state,
        loadingQueue: false,
      };
    case statisticTypes.GET_STATISTICS_CLIENTS.REQUEST:
      return {
        ...state,
        loadingClients: true,
      };
    case statisticTypes.GET_STATISTICS_CLIENTS.SUCCESS:
      return applySuccess(state, 'clients', 'loadingClients', action);
    case statisticTypes.GET_STATISTICS_CLIENTS.FAILED:
      return {
        ...state,
        loadingClients: false,
      };
    default:
      return { ...state };
  }
};
